export default __webpack_public_path__ + "static/media/metamask-icon.8654f984.svg";